import React from 'react';
import { Calendar, Package } from 'lucide-react';
import { format } from "date-fns";
import { ParcelDetails } from "@/hooks/bookings/types";
interface PackageInfoProps {
  parcels: ParcelDetails[];
  totalParcelsCount: number | null;
  collectionDatetime: string | null;
}
const PackageInfo: React.FC<PackageInfoProps> = ({
  parcels,
  totalParcelsCount,
  collectionDatetime
}) => {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return "Not specified";
    try {
      return format(new Date(dateString), "PPP 'at' h:mm a");
    } catch (e) {
      return dateString;
    }
  };
  const getPackageSummary = () => {
    const totalCount = totalParcelsCount || (parcels ? parcels.length : 0);
    if (!parcels || parcels.length === 0) {
      return `${totalCount} parcels`;
    }
    if (parcels.length === 1) {
      const parcel = parcels[0];
      const typeLabels: Record<string, string> = {
        "documents": "Documents",
        "small-packages": "Small Packages",
        "fragile": "Fragile Items",
        "food": "Food Items",
        "medical": "Medical Supplies",
        "large": "Large Items",
        "special": "Special Items",
        "other": "Other Items"
      };
      const typeLabel = typeLabels[parcel.parcel_type] || parcel.parcel_type;
      const description = parcel.description ? ` - ${parcel.description}` : '';
      return parcel.quantity > 1 ? `${parcel.quantity}x ${typeLabel}${description}` : `${typeLabel}${description}`;
    }
    return `${totalCount} parcels (mixed types)`;
  };
  return <div className="mt-4 grid grid-cols-1 gap-4">
      <div className="flex items-start">
        <Package className="h-4 w-4 text-gray-400 mr-2 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <p className="font-medium text-card-foreground mb-1">Package</p>
          <p className="text-sm text-muted-foreground mb-2">{getPackageSummary()}</p>
          
          {/* Weight and dimensions - responsive layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-muted-foreground ">
            <div>
              <span className="font-medium">Weight:</span> {parcels?.reduce((sum, p) => sum + parseFloat(p.weight || '0') * p.quantity, 0).toFixed(1) || '0'} kg
            </div>
            <div>
              <span className="font-medium">Dimensions:</span>{' '}
              {parcels && parcels.length === 1 && parcels[0].dimensions ? `${parcels[0].dimensions.length} × ${parcels[0].dimensions.width} × ${parcels[0].dimensions.height} cm` : 'Various'}
            </div>
          </div>
        </div>
      </div>
      
      <div className="flex items-start">
        <Calendar className="h-4 w-4 text-gray-400 mr-2 mt-0.5 flex-shrink-0" />
        <div>
          <p className="font-medium text-card-foreground mb-1">Collection Date</p>
          <p className="text-sm">{formatDate(collectionDatetime)}</p>
        </div>
      </div>
    </div>;
};
export default PackageInfo;